import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { InspectionTemplateHttpRestoreRequestModel } from '../httpQueue/inspectionTemplate/types';

export interface RestoreInspectionTemplateParams {
  templateId: string;
  projectId: string;
  uniqueId: string;
}

export class InspectionTemplateRestorer {
  constructor(
    private addRequest: (
      request: InspectionTemplateHttpRestoreRequestModel
    ) => Promise<unknown>
  ) {}

  async execute({
    templateId,
    projectId,
    uniqueId,
  }: RestoreInspectionTemplateParams): Promise<void> {
    debugLog('RestoreInspectionTemplateUseCase', templateId);
    await this.addRequest({
      createdAt: Date.now(),
      method: 'GET',
      data: {
        templateId,
        projectId,
        uniqueId,
      },
      url: `/project/${projectId}/inspectionTemplate/${templateId}/restore`,
      entityType: HttpRequestModelType.inspectionTemplate,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionTemplateRestorer = new InspectionTemplateRestorer(
  addRequest
);
